var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('sidebar-menu'),_c('h1',[_vm._v("This is an about page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }